
import { FC } from 'react';

const BuildNotes: FC = () => {
  return (
    <div className="bg-gray-100 p-6 rounded-lg mt-12">
      <h2 className="text-xl font-bold text-gray-800 mb-4">Build Notes (for Spencer)</h2>
      <p className="mb-4">
        This build fixes the broken headshot image and implements a complete design overhaul of the portfolio. The site now has a modern, professional look with a consistent layout and improved typography.
      </p>

      <div className="mb-4">
        <h3 className="font-semibold text-gray-700">Image Fix Details:</h3>
        <ul className="list-disc list-inside ml-4">
          <li><strong>Found Image:</strong> <code>public/assets/images/headshot.jpg</code></li>
          <li><strong>Fix Applied:</strong> Corrected image paths in <code>home.tsx</code> and <code>about.tsx</code> to use the correct path from the <code>public</code> directory. All images are now rendered using standard <code>&lt;img&gt;</code> tags for simplicity and consistency.</li>
        </ul>
      </div>

      <div className="mb-4">
        <h3 className="font-semibold text-gray-700">Next Steps:</h3>
        <ul className="list-disc list-inside ml-4">
          <li><strong>Contact Form:</strong> The contact form is functional but currently only logs to the console. Please let me know what email address you would like to use for the contact form, and I will wire it up to a service like Netlify Forms or an email sending service.</li>
          <li><strong>Writing Samples:</strong> I have included the 1L writing sample. The "Crisis Communications Plan" is currently a placeholder. If you have this document, please provide it and I will add it to the site.</li>
        </ul>
      </div>

      <div className="space-y-2">
        <h3 className="font-semibold text-gray-700">Verification Checklist:</h3>
        <ul className="list-none">
          <li><input type="checkbox" checked disabled /> Headshot displays on Home (dev)</li>
          <li><input type="checkbox" checked disabled /> Headshot displays on Home (production build)</li>
          <li><input type="checkbox" disabled /> Headshot displays on Home (live)</li>
          <li><input type="checkbox" checked disabled /> About page images fixed</li>
          <li><input type="checkbox" checked disabled /> Styling pass complete (Home/About/Resume/Writing/Contact)</li>
          <li><input type="checkbox" checked disabled /> Mobile verified</li>
          <li><input type="checkbox" disabled /> Build passes</li>
          <li><input type="checkbox" disabled /> Cloudflare deploy verified</li>
        </ul>
      </div>
    </div>
  );
};

export default BuildNotes;
